import { filter, isArray } from 'lodash'

export const filterWithMultipleMatches = (collections, filterObj) => {
  if (isArray(collections)) {
    return filter(collections, filterObj)
  }
}

// Filter TCIN's only from the collections, Result --> ["52764237", "51945064", "52231985"]
export const filterTCINs = (collections) =>
  collections?.map((item) => item.tcin)

export const mapFiltersToArray = (filters) => {
  const appliedFilters = filters?.applied
  const resultArray = []
  if (appliedFilters) {
    for (const key in appliedFilters) {
      if (appliedFilters[key]) {
        const filterObject = {
          id: key,
          values: appliedFilters[key].values.map(({ value, displayValue }) => ({
            value,
            displayValue,
          })),
        }
        resultArray.push(filterObject)
      }
    }
  }

  return resultArray
}

/**
 * to convert an array of objects
 * @param {Array} array
 * @param {string} key
 * @returns {Object}
 */

export const arrayToObject = (array, key) =>
  array.reduce((acc, curr) => {
    acc[curr[key]] = curr
    return acc
  }, {})

/**
 * to convert our exisiting AttributeSchemaValue to canvas option format
 * @param {options} array // Options array with object of type AttributeSchemaValue
 */

export const formatOptions = (options) => {
  return options.map((option) => ({
    value: option.value,
    id: JSON.stringify(option.value),
    label: option.displayValue,
  }))
}

/**
 * to convert object to array
 * @param {Object} filterObject
 * @returns {Object}
 */

export const convertFiltersToArray = (filterObject) => {
  if (!filterObject || typeof filterObject !== 'object') {
    return []
  }

  return Object.keys(filterObject).map((key) => filterObject[key])
}

/**
 * Checks if the current domain includes 'itemhub'.
 */
export const isItemhubDomain = window.location.host.includes('itemhub')

// Detect the Partneronline | External or Internal users
export const isPartnerOnline = () => {
  const url = window.location.href
  return /(^([^/]+:)?\/{2,3}[^/]+?(\.partnersonline\.com)(:|\/|$))/i.test(url)
}
const isItemHubDomainExternal = () => {
  const regex =
    /^https:\/\/itemhub\.(?:[a-zA-Z]+\.)?partnersonline\.com(?:\/.*)?$/i // Itemhub External environment - Partners online
  return regex.test(window.location.href)
}
export const isItemhubDomainInInternal = () => {
  // const regex = /^https:\/\/itemhub\.(\w+)\.target\.com\/(\w+)\/.*$/i // Itemhub Internal environment - dev|prod.target.com
  const regex = /^https:\/\/itemhub\.(?:[a-zA-Z]+\.)?target\.com(?:\/.*)?$/i
  // const regex = /^https:\/\/itemhub\.(\w+)\.target\.com\/(\w+)\/?$/i
  return regex.test(window.location.href)
}
export const LoginRedirectPath = () => {
  let url = `${window.location.origin}/auth/login`
  if (isItemHubDomainExternal() || isItemhubDomainInInternal()) {
    url = `${window.location.origin}/${window.location.pathname.split('/')[1]}`
  }
  return url
}

export const findAppPath = () => {
  const localhostLists = ['localhost', 'localhost.target.com']
  const hostname = window.location.hostname
  const isLocal = localhostLists.includes(hostname)

  if (isLocal) {
    return ''
  }

  const pathSegments = window.location.pathname.split('/')
  const dynamicPath = pathSegments[1] ? `/${pathSegments[1]}` : ''

  if (isItemhubDomainInInternal() || isItemHubDomainExternal()) {
    return dynamicPath
  }

  return ''
}
